const LeftArrowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polyline
        points="30,10 15,25 30,40"
        fill="none"
        stroke="white"
        stroke-width="4"
      />
    </svg>
  );
};

export default LeftArrowIcon;
